import './breadcrumbs.scss';

import { LocalizedLink } from '../localized-link';
import type { TBreadcrumbs } from './types';

interface IProps {
  breadcrumbs: TBreadcrumbs;
  className?: string;
}

const Breadcrumbs = ({ breadcrumbs, className }: IProps) => {
  return (
    <nav className={'breadcrumbs ' + (className || '')} aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {breadcrumbs.map((b, idx) => (
          <li className="breadcrumbs__item" key={b.title}>
            {idx < breadcrumbs.length - 1 ? (
              <LocalizedLink className="breadcrumbs__link" to={b.href}>
                {b.title}
              </LocalizedLink>
            ) : (
              <span className="breadcrumbs__current" aria-current="page">
                {b.title}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
